<template>
  <div class="ms-container full-width time-table">
    <div class="time-table-controls filters-bar">
      <time-table-filter />
      <div class="time-table-export">
        <i-button type="default" @click="toggleSelectMode">
          {{ selectedMode ? 'Отменить выбор' : 'Выбрать проекты' }}
        </i-button>
        <i-button @click="exportTable" type="success">
          Экспорт {{ selectedMode ? `выбранных (${selectedToExport.length})` : 'всей таблицы' }}
        </i-button>
      </div>
    </div>
    <div class="time-table-container">
      <inline-loader :loading="loading" v-if="loading && !nodata" />
      <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
        Не удалось загрузить план-график
      </div>
      <div class="time-table-content" v-else-if="projects.length">
        <time-table-list ref="list" :projects="filteredProjects" @update-table="getData" />
        <div class="time-table-pagination">
          <page
            :total="total"
            :current="current"
            :page-size="count"
            @on-change="changePage"
          />
        </div>
      </div>
      <div class="ms-nodata ms-text" v-else>
        Проекты отсутствуют
      </div>
    </div>
  </div>
</template>

<script>
import InlineLoader from '@/components/loaders/inline-loader'
import TimeTableList from '@/components/time-table/time-table-list'
import TimeTableFilter from '@/components/filters/time-table'
import { mainUrl } from '@/config/urls'
import { downloadFile } from '@/utils'
import { getTimeTableUrl } from '@/config/filters'

export default {
  components: {
    InlineLoader,
    TimeTableList,
    TimeTableFilter
  },
  data () {
    return {
      loading: false,
      nodata: false,
      projects: [],
      token: this.$store.state.auth.token,
      current: 1,
      count: 15,
      total: 20
    }
  },
  computed: {
    filteredProjects () {
      const currentIndex = (this.current - 1) * this.count

      return this.projects.slice(currentIndex, currentIndex + this.count)
    },
    selectedMode () {
      return this.$store.state.selectedMode
    },
    selectedToExport () {
      return this.$store.state.selectedToExport
    }
  },
  watch: {
    '$store.state.filters.timeTable': {
      handler: async function () {
        await this.getData()
        this.current = 1
      },
      deep: true
    },
    '$store.state.filters.company': function () {
      this.getData()
    }
  },
  methods: {
    toggleSelectMode () {
      const value = this.selectedMode

      if (value) this.$store.commit('CLEAR_SELECTED_CONTRACTS')
      this.$store.commit('TOGGLE_SELECTED_MODE', !value)
    },
    changePage (page) {
      this.current = page

      this.$refs.list.opened = []
    },
    async getData () {
      try {
        this.loading = true

        const url = getTimeTableUrl(`page/project`, this.$store.state.filters)
        const data = await this.$store.dispatch('GET_REQUEST', { url })
        this.projects = data.map(p => ({
          ...p,
          loading: false,
          roadmap: []
        }))
        this.total = data.length

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    exportTable () {
      let baseUrl

      if (!this.selectedMode) {
        baseUrl = getTimeTableUrl(
          `page/project`,
          this.$store.state.filters
        )
      } else {
        baseUrl = `page/project?contract_id=${this.selectedToExport.join(',')}`
        this.toggleSelectMode()
      }

      const url = `${mainUrl}/api/${baseUrl}&format=excel&access_token=${this.token}`

      downloadFile(url)
    }
  },
  async created () {
    await this.getData()
  }
}
</script>

<style lang="less">
.time-table {
  &-export {
    .ivu-btn {
      &:not(:first-child) {
        margin-left: 8px;
      }
    }
  }

  &-pagination {
    margin-top: 16px;
    display: flex;
    justify-content: center;
  }
}
</style>
